import React, { useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import TextLoop from 'react-text-loop';
import { Row, Col, Typography, Button, Divider, Space, Select } from 'antd';
import useChangeLanguage from '../../../../containers/hooks/useChangeLanguage';
import { ReactComponent as TogetherSvg } from '../../../../assets/icons/together.svg';
import { ReactComponent as GoogleSvg } from '../../../../assets/icons/google-colour.svg';
import { ReactComponent as FacebookSvg } from '../../../../assets/icons/facebook.svg';

const { Title } = Typography;

const styles = {
  divider: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
  rowButton: {
    margin: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    fontWeight: "300",
    fontSize: "20px",
    lineHeight: "24px",
    textAlign: "center",
    color: "#404047",
    marginBottom: 40
  },
  privacy: {
    fontSize: 14,
    fontWeight: 28,
    color: '#999999',
    margin: 0
  },
}

function MobileSignUpMethodScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();
  const { lang, langOptions, changeLanguage } = useChangeLanguage();

  const onChange = (value) => {
    const [language, direction] = value;
    changeLanguage(language, direction);
  }

  const onSignupWithEmail = () => {
    history.push('/sign-up/form/account-info');
  }

  const onSignupWithGoogle = () => {

  }

  const onSignupWithFacebook = () => {

  }

  return (
    <Box position="relative" paddingTop={24} paddingBottom={12} paddingX={20} marginBottom={40}>
      <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
        <img
          alt='AlemHealth'
          src={`${window.location.origin  }/alem_health_logo.png`}
          style={{
            objectFit: 'contain',
            margin: 0,
            padding: 0,
            height: 40,
          }}
        />
      </Row>
      <Box marginTop={25} marginBottom={42}>
        <Row type="flex" align="middle" gutter={24} style={{ width: '100%' }}>
          <Col>
            <div className="language-label">
              <TextLoop>
                {langOptions.map(({ value }) => (
                  <Title key={value} level={4} style={styles.welcomeTitle}>
                    {t(`common:language.title.${value}`)}
                  </Title>
                ))}
              </TextLoop>
            </div>
          </Col>
          <Col flex={1}>
            <div>
              <Select
                style={{ width: '90%' }}
                size="large"
                value={t(`common:language.${lang}`)}
                onChange={onChange}
              >
                {langOptions.map(({ value, direction }) => (
                  <Select.Option key={value} value={[value, direction]}>
                    {t(`common:language.${value}`)}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Col>
        </Row>
      </Box>
      <Box display="flex" justifyContent="center">
        <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box textAlign="center">
        <Row gutter={[0, 24]}>
          <Col xs={24}>
            <Title level={4} style={styles.title}>
              {t('sign-up:guest.letsGetYouSignup')}
            </Title>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Box marginBottom={30}>
                <Button
                  htmlType="button"
                  type="primary"
                  size="large"
                  onClick={onSignupWithEmail}
                  block
                >
                  {t('sign-up:guest.signUpWithEmail')}
                </Button>
              </Box>
              {/* <Box>
                <Divider plain><p style={styles.divider}>{t('sign-up:guest.orSignUpWith')}</p></Divider>
              </Box>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                onClick={onSignupWithGoogle}
                block
                ghost
              >
                <p style={styles.rowButton}>
                  <GoogleSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithGoogle')}
                </p>
              </Button>
              <Button
                htmlType="button"
                type="primary"
                size="large"
                onClick={onSignupWithFacebook}
                block
                ghost
                style={{alignItems: 'center'}}
              >
                <p style={styles.rowButton}>
                  <FacebookSvg style={{ marginRight: 5 }}/>{t('welcome:signIn.loginWithFacebook')}
                </p>
              </Button> */}
            </Space>
          </Col>
        </Row>
      </Box>
      <Box height="100px" marginBottom="50px" />
      <Box position="absolute" bottom="50px" marginLeft="auto" marginRight="auto" left="0" right="0" minWidth="320px" paddingX={20}>
        <div style={{ textAlign: 'center'}}>
          <Link to="/privacy" style={styles.privacy}>{t('welcome:signIn.privacy')}</Link>
        </div>
      </Box>
    </Box>
  );
}

export default MobileSignUpMethodScreen;
